export default class ExtraChargeOption {
  constructor(
    private fUpgradeCode: string,
    private fUpgradeName: string,
    private fIsSelectable: boolean,
    private fIsMultiplePurchaseAllowed: boolean | undefined
  ) {
    if (
      fUpgradeCode === undefined ||
      fUpgradeName === undefined ||
      fIsSelectable === undefined
    ) {
      throw new Error("Required ExtraChargeOption arguments are missing");
    }
  }

  get upgradeCode(): string {
    return this.fUpgradeCode;
  }

  get upgradeName(): string {
    return this.fUpgradeName;
  }

  get isSelectable(): boolean {
    return this.fIsSelectable;
  }

  get isMultiplePurchaseAllowed(): boolean | undefined {
    return this.fIsMultiplePurchaseAllowed;
  }
}
